"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_observable_1 = require("redux-observable");

var Subject_1 = require("rxjs/internal/Subject");

function runEpic(epic, action, state) {
  var dependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return epic(redux_observable_1.ActionsObservable.of(action), new redux_observable_1.StateObservable(new Subject_1.Subject(), state), dependencies);
}

exports.runEpic = runEpic;